// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__18-J8","inner":"Footer_inner__2bg_W"};